import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PrivateCloudDevices } from "@/features/p2p-cloud/components/private-cloud-devices";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@fleet/ui";

function DevicesPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Private cloud devices`)}
      description={t(msg`Pair and manage the trusted devices of your private P2P cloud.`)}
    >
      <PageContainer maxWidth="3xl">
        <PrivateCloudDevices />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const devicesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/devices",
  component: DevicesPage,
});
